import { render, staticRenderFns } from "./StudioLogin.vue?vue&type=template&id=af995124&scoped=true&"
import script from "./StudioLogin.vue?vue&type=script&lang=js&"
export * from "./StudioLogin.vue?vue&type=script&lang=js&"
import style0 from "./StudioLogin.vue?vue&type=style&index=0&id=af995124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af995124",
  null
  
)

export default component.exports